import { render, staticRenderFns } from "./editorlog.vue?vue&type=template&id=7487ce88&scoped=true"
import script from "./editorlog.vue?vue&type=script&lang=js"
export * from "./editorlog.vue?vue&type=script&lang=js"
import style0 from "./editorlog.vue?vue&type=style&index=0&id=7487ce88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7487ce88",
  null
  
)

export default component.exports